import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap';
import SearchInput from '../common/search/searchInput';
import ControlFilterSwitch from '../common/controls/controlFilterSwitch';
import tieredFilterEntity from '../common/lookups/tieredFilterEntity';
import searchFactory from '../common/lookups/searchFactory';
import Icon from '../common/containers/icon';
import pagerFactory from '../common/pagingTable/pagerFactory';
const DocumentJobFilter = tieredFilterEntity('document', 'jobFilterDocument', 'jobs');
const DocumentJobPager = pagerFactory('jobFilterDocument');
const DocumentJobSearch = searchFactory('jobFilterDocument');
const DocumentTagFilter = tieredFilterEntity('document', 'documentTagFilterDocument', 'tags');
const DocumentTagSearch = searchFactory('documentTagFilterDocument');
const DocumentsFilter = _ref => {
  let filters = _ref.filters,
    onFilterChange = _ref.onFilterChange,
    onFilterClear = _ref.onFilterClear;
  // must be declared here so the ref callback can refer to it
  let controlFilterSwitch = null;

  // needed for the issue items control.
  const handleBack = () => {
    controlFilterSwitch.controlSwitch.switchControl();
  };
  const handleFilterChangeText = text => onFilterChange('text', text);
  const handleFilterChangeTextClear = () => onFilterChange('text', '');
  const getDisplayName = option => _objectSpread(_objectSpread({}, option), {}, {
    name: option.jobNumber
  });
  const jobSelect = /*#__PURE__*/React.createElement(DocumentJobFilter, {
    label: "Jobs",
    getOptionName: getDisplayName,
    onBack: handleBack,
    searchLocally: false
  }, /*#__PURE__*/React.createElement(DocumentJobSearch, null), /*#__PURE__*/React.createElement(DocumentJobPager, null));
  const documentTagSelect = /*#__PURE__*/React.createElement(DocumentTagFilter, {
    label: "Tags",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(DocumentTagSearch, null));
  const filterControls = [{
    filterName: 'jobs',
    label: 'Jobs',
    entity: 'job',
    control: jobSelect,
    filters
  }, {
    filterName: 'tags',
    label: 'Tags',
    entity: 'documentTags',
    control: documentTagSelect,
    filters
  }];
  return /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", null, "Filter")), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: onFilterClear,
    className: "float-md-right t-df-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
    className: "document-filters",
    type: "text",
    text: filters.text,
    onChange: handleFilterChangeText,
    onClear: handleFilterChangeTextClear
  }), /*#__PURE__*/React.createElement(ControlFilterSwitch, {
    className: "t-df-filters",
    filterControls: filterControls,
    ref: input => {
      controlFilterSwitch = input;
    }
  }))));
};
DocumentsFilter.propTypes = {
  filters: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onFilterClear: PropTypes.func.isRequired
};
export default DocumentsFilter;